export const urlSearchParamsToObject = <Params extends Record<string, string>>(params: URLSearchParams): Params => {
  return Array.from(params.entries()).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: value,
    }),
    {} as Params,
  );
};
